import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../store/slices/authSlice';
import './LoginForm.scss';

function LoginForm({ onRegisterClick, onForgotPasswordClick }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.auth);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      alert('Please enter both email and password');
      return;
    }
    
    try {
      await dispatch(loginUser({ email, password })).unwrap();
    } catch (err) {
      console.error('Login failed:', err);
    }
  };
  
  return (
    <div className="login-form-container">
      <div className="login-form-header">
        <h2>Sign In</h2>
        <p>Access your FredoCloud account</p>
      </div>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
          <div className="forgot-password">
            <button 
              type="button" 
              className="link-button"
              onClick={onForgotPasswordClick}
            >
              Forgot Password?
            </button>
          </div>
        </div>
        
        <button 
          type="submit" 
          className="btn btn-primary login-button"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? 'Signing In...' : 'Sign In'}
        </button>
      </form>
      
      <div className="login-footer">
        <p>Don&apos;t have an account? <button onClick={onRegisterClick} className="link-button">Create Account</button></p>
      </div>
    </div>
  );
}

export default LoginForm; 